export const AUTH_AUDIENCE = "https://app.c3posttrade.com/graphql";
export const API_URI =
  process.env.NODE_ENV === "production"
    ? "/graphql"
    : "http://localhost:4000/graphql";
export const APP_STATE_STORAGE_KEY = "APP_STATE";
export const SUPPORT_EMAIL = "c3operations@c3posttrade.com";
export const USER_IMPERSONATION_COOKIE_KEY = "IMPERSONATION_STATE";
export const PERMISSION_TO_DISPLAY_LINK_TO_CURRENT_GEN =
  "/c3v5/root/login/action";
